module.exports = __webpack_public_path__ + "static/media/APP_NightWatch_152x174_3.a8721dba.png";